import React, { Fragment } from 'react';
import { ApiNote } from '../api';
import './Note.scss';
import { AppState } from '../store/store';
import { connect, ResolveThunks } from 'react-redux';
import AlertModal from './AlertModal';
import { saveNote } from './amlActions';
import FormattedDateTime from '../common/datetime/FormattedDateTime';
import { ContentPreviewer } from '../common/ContentPreviewer';

interface NoteProps {
  note: ApiNote;
  personId: string | null;
}

export const Note = ({ note, personId, alerts }: Props) => {
  const userName = note.user?.name ?? 'System';
  const alert = note.alertId && alerts.find((alert) => alert.id === note.alertId);

  return (
    <Fragment>
      <p className='m-0'>
        <b>
          {`${userName}, `} <FormattedDateTime date={note.createdTime} showTime={true} />
        </b>
      </p>
      {alert && personId && <AlertModal alert={alert} personId={personId} />}
      <ContentPreviewer previewLinesAmount={1}>{note.content}</ContentPreviewer>
    </Fragment>
  );
};

const mapStateToProps = ({ aml }: AppState) => {
  return {
    alerts: aml.alerts.content,
  };
};

const mapDispatchToProps = {
  saveNote,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & NoteProps;

export default connect(mapStateToProps, mapDispatchToProps)(Note);
